import { render, staticRenderFns } from "./edit-workflow-form.vue?vue&type=template&id=670a237f&scoped=true&"
import script from "./edit-workflow-form.vue?vue&type=script&lang=js&"
export * from "./edit-workflow-form.vue?vue&type=script&lang=js&"
import style0 from "./edit-workflow-form.vue?vue&type=style&index=0&id=670a237f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670a237f",
  null
  
)

export default component.exports